import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";

const fadeUp = (delay = 0) => ({
  hidden:  { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut", delay } },
});

function scrollTo(href) {
  const el = document.querySelector(href);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 76, behavior: "smooth" });
}

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative flex flex-col items-center justify-center min-h-dvh pt-[76px] bg-white overflow-hidden"
      aria-labelledby="hero-heading"
    >
      {/* Subtle geometric background */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(ellipse 70% 60% at 50% 0%, rgba(26,107,124,0.05) 0%, transparent 70%),
            radial-gradient(ellipse 50% 40% at 90% 100%, rgba(90,154,138,0.06) 0%, transparent 60%)
          `,
        }}
      />

      {/* Thin decorative horizontal line */}
      <div
        aria-hidden="true"
        className="absolute top-[76px] inset-x-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, rgba(26,107,124,0.18) 30%, rgba(26,107,124,0.18) 70%, transparent)" }}
      />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 py-24 text-center" id="main-content">

        {/* Eyebrow */}
        <motion.p
          variants={fadeUp(0)}
          initial="hidden"
          animate="visible"
          className="font-sans text-sm font-semibold tracking-widest text-primary uppercase mb-6"
        >
          Arequipa, Perú
        </motion.p>

        {/* Heading */}
        <motion.h1
          id="hero-heading"
          variants={fadeUp(0.1)}
          initial="hidden"
          animate="visible"
          className="font-serif font-bold text-[2.4rem] sm:text-5xl lg:text-[3.4rem] text-navy leading-[1.15] mb-6"
          style={{ letterSpacing: "-0.01em" }}
        >
          Potenciando el neurodesarrollo de tu hijo en cada etapa de su vida
        </motion.h1>

        {/* Subheading */}
        <motion.p
          variants={fadeUp(0.2)}
          initial="hidden"
          animate="visible"
          className="font-sans text-lg sm:text-xl text-txtMuted leading-relaxed mb-10 max-w-2xl mx-auto"
        >
          Especialistas en diagnóstico y terapia para niños, adolescentes y adultos en Arequipa.
        </motion.p>

        {/* CTAs */}
        <motion.div
          variants={fadeUp(0.3)}
          initial="hidden"
          animate="visible"
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            onClick={() => scrollTo("#contacto")}
            className="btn-primary text-base px-8 py-3.5"
          >
            Agendar evaluación
            <ArrowRight size={17} aria-hidden="true" />
          </button>
          <button
            onClick={() => scrollTo("#terapias")}
            className="btn-outline text-base px-8 py-3.5"
          >
            Conocer servicios
          </button>
        </motion.div>

        {/* Scroll cue */}
        <motion.button
          onClick={() => scrollTo("#franja")}
          variants={fadeUp(0.5)}
          initial="hidden"
          animate="visible"
          aria-label="Desplazar hacia abajo"
          className="mt-16 flex flex-col items-center gap-2 mx-auto text-txtMuted hover:text-primary transition-colors cursor-pointer group"
          style={{ background: "none", border: "none", padding: 0 }}
        >
          <span className="font-sans text-xs tracking-widest uppercase opacity-60">Descubrir más</span>
          <motion.div
            animate={{ y: [0, 6, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <ChevronDown size={20} />
          </motion.div>
        </motion.button>
      </div>
    </section>
  );
}
